// extracted by mini-css-extract-plugin
export default {"control":"MobileNavbar_control__bLl0w"};